import { jsx as _jsx } from "react/jsx-runtime";
import { useCreateEmojis, useUploadFile } from '@tribeplatform/react-sdk/hooks';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { toast } from '@tribeplatform/react-ui-kit/Toast';
import { useI18n } from '../i18n';
import { PopoverImagePicker } from '../Picker/PopoverImagePicker';
export const ImagePickerBlockField = ({ onChange, removable, tabs = ['emoji', 'upload', 'link', 'unsplash'], image, }) => {
    const intl = useI18n();
    const { uploadFile: upload, loading } = useUploadFile();
    const { mutateAsync: createEmojis } = useCreateEmojis({
        useMutationOptions: {
            onError: () => {
                toast({
                    title: intl.$t({
                        id: 'Generics.SomethingWentWrong',
                        defaultMessage: 'Something went wrong',
                    }),
                    status: 'error',
                });
            },
        },
    });
    const uploadFile = async (files) => {
        const file = files[0];
        upload(file, async (uploadedImage) => {
            if (uploadedImage.id) {
                onChange(uploadedImage);
            }
        });
    };
    return (_jsx(PopoverImagePicker, { tabs: tabs, removable: removable && !!image, onRemove: () => {
            onChange(null);
        }, onEmojiChange: async (emoji) => {
            const uploadedEmoji = await createEmojis([{ text: emoji === null || emoji === void 0 ? void 0 : emoji.id }]);
            onChange(uploadedEmoji[0]);
        }, onImageChange: uploadFile, sizeConfig: {
            recommendedWidth: 1200,
            recommendedHeight: 440,
        }, children: _jsx(Button, { variant: "outline", loading: loading, disabled: loading, children: image
                ? intl.$t({
                    id: 'Generics.Change.Verb',
                    defaultMessage: 'Change',
                })
                : intl.$t({ id: 'Generics.Add', defaultMessage: 'Add' }) }, void 0) }, void 0));
};
//# sourceMappingURL=ImagePickerBlockField.js.map